import { render, staticRenderFns } from "./SitePageKeyword.vue?vue&type=template&id=f1aac60c&"
import script from "./SitePageKeyword.vue?vue&type=script&lang=js&"
export * from "./SitePageKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports